import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ConsumerSidebarComponent } from '../sidebar/consumer-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { SupportComponent } from '../../shared/components/support/support.component';

@Component({
  selector: 'app-consumer-support',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ConsumerSidebarComponent,
    PageHeaderComponent,
    SupportComponent
  ],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
})
export class ConsumerSupportComponent {}




